import { gsap } from "gsap";

export default class Buttons {
  constructor() {

  }

  init() {
    this.scrollNext();
    this.initSlideOpen();
  }

  scrollNext() {
    let $el = $(".js-scroll-next");

    if(!$el.length) return;

    $el.click((e) => {
      e.preventDefault();
      let $parent = $(e.currentTarget).parents("section");
      let $next = $parent.next();

      gsap.to("html, body", .8, {
        scrollTop: $next.offset().top,
        ease: "Expo.easeInOut"
      });
    });
  }

  initSlideOpen() {
    let $slideBtns = $("[data-slide-open]");

    $slideBtns.each((i, btn) => {
      let $btn = $(btn);
      let $target = $($btn.data("slide-open"));

      $btn.click((e) => {
        e.preventDefault();
        $(e.currentTarget).toggleClass("active");

        $target.slideToggle('slow', () => {
          window.scrollTo({
            top: $target.position().top,
            behavior: "smooth"
          });
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./static/js/components/Buttons.js